import script from "./HeaderApp.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderApp.vue?vue&type=script&setup=true&lang=js"

import "./HeaderApp.vue?vue&type=style&index=0&id=6505c07c&lang=scss"

const __exports__ = script;

export default __exports__